<div class="min-h-screen w-full flex flex-col justify-between bg-surface relative overflow-hidden select-none">
  <!-- Ambient background glow in Juboo brand colors -->
  <div class="absolute -top-32 -left-32 w-96 h-96 bg-primary-100/50 rounded-full blur-3xl pointer-events-none"></div>
  <div class="absolute -bottom-32 -right-32 w-96 h-96 bg-secondary-100/40 rounded-full blur-3xl pointer-events-none"></div>

  <!-- Top bar with Logo -->
  <header class="w-full max-w-7xl mx-auto px-6 py-6 flex items-center relative z-10">
    <a routerLink="/" class="flex items-center focus:outline-none">
      <img
        src="assets/logo-juboo-bg.png"
        alt="Juboo"
        class="h-9 sm:h-10 w-auto object-contain"
      />
    </a>
  </header>

  <!-- Main 404 Content -->
  <main class="w-full max-w-2xl mx-auto px-6 py-12 flex flex-col items-center text-center relative z-10 animate-fade-in">
    <!-- 404 Badge & Graphic -->
    <div class="relative mb-6">
      <span class="text-8xl sm:text-9xl font-black text-primary/10 tracking-widest select-none block">
        404
      </span>
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-secondary/10 border border-secondary/30 flex items-center justify-center text-secondary shadow-card">
          <svg class="w-8 h-8 sm:w-10 sm:h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Badge -->
    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-primary-100 text-primary-800 border border-primary-200/80 mb-3">
      {{ 'NOT_FOUND.BADGE' | translate }}
    </span>

    <!-- Heading with Juboo primary color -->
    <h1 class="text-2xl sm:text-4xl font-bold text-primary tracking-tight mb-3">
      {{ 'NOT_FOUND.TITLE' | translate }}
    </h1>

    <!-- Description -->
    <p class="text-sm sm:text-base text-stone-600 max-w-md mx-auto mb-8 leading-relaxed">
      {{ 'NOT_FOUND.DESCRIPTION' | translate }}
    </p>

    <!-- Actions (centered) -->
    <div class="flex flex-col sm:flex-row items-center justify-center gap-3 w-full sm:w-auto">
      <app-button
        variant="primary"
        size="md"
        customClass="w-full sm:w-auto shadow-xs"
        (btnClick)="goHome()"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        {{ 'NOT_FOUND.BACK_HOME' | translate }}
      </app-button>

      <app-button
        variant="secondary"
        size="md"
        customClass="w-full sm:w-auto"
        (btnClick)="goBack()"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        {{ 'NOT_FOUND.BACK_PREVIOUS' | translate }}
      </app-button>
    </div>
  </main>

  <!-- Footer -->
  <footer class="w-full py-4 text-center text-xs text-stone-400 relative z-10 select-none">
    © Juboo — {{ currentYear }}
  </footer>
</div>
